<template>
<div class="a7-painel-mobile">
  <div class="superior">
    <div class="navigation" v-if="pai">
      <div class="item pai-container" @click="goBack">
        <div class="pai">
          {{pai.nivel}}
        </div>
      </div>
      <div class="item">
        <span class="title" v-if="atual">{{atual.nivel}}
        </span>
      </div>
    </div>
    <div class="navigation" v-else-if="!pai">
      <div class="item">
        <span class="title" v-if="atual">{{atual.nivel}}
        </span>
      </div>
    </div>
    <div class="navigation">
      <a7-painel-parameter @filtrou="emitFiltrou"/>
    </div>
        <!-- <a7-painel-mobile-values-bar :values="values"/> -->
  </div>
  <div class="lista" v-if="atual && atual.filhos">
    <gw-list :items="atual.filhos" separator>
      <template v-slot:listItem="{ item }">
        <a7-painel-mobile-item
        :item="item"
        @selected="selectedItem(item)"
        @information="information(item)"/>
      </template>
    </gw-list>
  </div>

  <div v-if="navigation!==null && !navigation.length">
    <h3 class="empty-message">
      {{`${$t('PainelMedicaoIndicador.ui.mobile.arrayVazio')}`}}
    </h3>
  </div>
  <gw-modal-dialog :visible="showDialog" @hide="closeModal">
    <span slot="modal-header" >
      {{entity.nivel}}
    </span>
    <div slot="modal-body">
      <gw-grouping-pane collapseDisabled
        :title="$t('PainelMedicaoIndicador.ui.modal.dicionario')"
        v-if="informacaoDicionario">
        <div class="informacao-complementar">
          <div>
            <span class="section-subtitle">
              {{`${$t('PainelMedicaoIndicador.ui.modal.unidadeMedida')}`}}
            </span>
            <span>{{informacaoDicionario.unidadeMedida}}</span>
          </div>

          <div>
            <span class="section-subtitle">
              {{`${$t('PainelMedicaoIndicador.ui.modal.desempenhoMinimo')}`}}
            </span>
            <span>{{informacaoDicionario.desempenhoMinimo}}</span>
          </div>

          <div>
            <span class="section-subtitle">
              {{`${$t('PainelMedicaoIndicador.ui.modal.desempenhoMaximo')}`}}
            </span>
            <span>{{informacaoDicionario.desempenhoMaximo}}</span>
          </div>
        </div>

        <div v-if="informacaoDicionario.objetivo">
          <span class="section-subtitle">
            {{`${$t('PainelMedicaoIndicador.ui.modal.objetivo')}`}}
          </span>
          <p>{{informacaoDicionario.objetivo}}</p>
        </div>
        <div v-if="informacaoDicionario.procedimento">
          <span class="section-subtitle">
            {{`${$t('PainelMedicaoIndicador.ui.modal.procedimento')}`}}
          </span>
          <p>{{informacaoDicionario.procedimento}}</p>
        </div>
        <div v-if="informacaoDicionario.risco">
          <span class="section-subtitle">
            {{`${$t('PainelMedicaoIndicador.ui.modal.risco')}`}}
          </span>
          <p>{{informacaoDicionario.risco}}</p>
        </div>
      </gw-grouping-pane>

      <gw-grouping-pane collapseDisabled :title="$t('PainelMedicaoIndicador.ui.modal.avaliacao')">
          <A7PainelAvaliacao
            :entity="entity"
            :filterParams="filtrosAtivos"/>
      </gw-grouping-pane>

      <gw-grouping-pane collapseDisabled :title="$t('PainelMedicaoIndicador.ui.modal.historico')">
        <A7HistoricoIndicador :painelIndicadorDTO="entity" :filterParams="filtrosAtivos"/>
      </gw-grouping-pane>
    </div>
    <div slot="modal-footer">
      <button class="btn btn-primary" type="button" @click="closeModal">
        Fechar
      </button>
    </div>
  </gw-modal-dialog>
</div>
</template>

<script>
import {
  GwList,
  GwButton,
  GwGroupingPane,
  GwModalDialog
} from 'guaxinim-web'

import A7PainelMobileItem from './A7PainelMobileItem'
// import A7PainelMobileValuesBar from './A7PainelMobileValuesBar'

import {agrupamentoDefaultMobile} from './A7PainelDefaultConfigurations'
import A7PainelParameter from './A7PainelParameter'
import A7PainelAvaliacao from './A7PainelAvaliacao'
import A7HistoricoIndicador from './A7HistoricoIndicador'
import IndicadorRestResource from '../indicador/IndicadorRestResource'

export default {
  name: "a7-painel-mobile",
  components: {
    GwList,
    GwButton,
    GwGroupingPane,
    A7PainelMobileItem,
    // A7PainelMobileValuesBar,
    A7PainelParameter,
    A7PainelAvaliacao,
    A7HistoricoIndicador,
    GwModalDialog
  },
  props: {
    itens: {
      type: Array,
      required: true
    },
    filtrosAtivos: {
      type: Object,
      default: {}
    }
  },
  data: () => ({
    navigation: null,
    navigationForwardCache: [],
    showDialog: false,
    indice: 0,
    entity: {},
    informacaoDicionario: null
  }),
  methods: {
    emitFiltrou(value) {
      this.$emit('filtrou', value)
    },
    emitAgrupou(value) {
      this.$emit('agrupou', value)
    },
    selectedItem(value) {
      if (value && value.filhos) {
        this.navigation.push(value)
        this.navigationForwardCache = [value]
        this.$router.push({ name: 'painel', query: { indice: this.navigation.length-1 } })
      }
    },
    goBack(){
      this.$router.go(-1)
    },
    backLevel() {
      this.navigationForwardCache.unshift(this.navigation.pop())
    },
    openModal() {
      this.showDialog = true
    },
    closeModal() {
      this.informacaoDicionario = null
      this.showDialog = false
    },
    information(item) {
      this.entity = item
      if (!item.indicadorID) {
        return this.openModal()
      }

      IndicadorRestResource.findDicionarioIndicadorDTObyID(item.indicadorID).then(indicador => {
        const dicionario = {
          indicador: indicador.nome,
          objetivo: indicador.objetivo,
          procedimento: indicador.procedimento,
          risco: indicador.risco,
          unidadeMedida: indicador.medicaoUnidadeMedida,
          desempenhoMaximo: indicador.desempenhoMaximo,
          desempenhoMinimo: indicador.desempenhoMinimo
        }
        this.informacaoDicionario = dicionario
        this.openModal()
      })
    },
  },
  computed: {
    atual(){
      if (this.navigation === null) return
      return  this.navigation[this.navigation.length-1]
    },
    pai(){
      if (this.navigation === null) return
      return this.navigation.length === 1 ? null : this.navigation[this.navigation.length-2]
    }
  },
  mounted() {
    this.emitAgrupou(agrupamentoDefaultMobile)
  },
  watch:{
    itens(value) {
      const vm = this
      if (value.length) {
        this.navigation = [value[0]]
        this.$router.replace({name: 'painel', query: { indice: 0 }})
      }
    },
    '$route.query': function(value, oldValue) {
      const tamanhoNavigation = this.navigation.length-1
      const indiceAtual = value.indice
      const indiceAnterior = oldValue.indice

      if (tamanhoNavigation > indiceAtual){
        this.backLevel()
      }
      else if( tamanhoNavigation < indiceAtual){
        if (!this.navigationForwardCache.length){
          return this.$router.replace({name: 'painel', query: { indice: indiceAnterior }})
        }
        const elementToForward = this.navigationForwardCache.shift()
        this.navigation.push(elementToForward)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './A7PainelFormatacao';

.informacao-complementar {
  margin-bottom: 10px;
}

.section-subtitle{
  font-weight: $weight;
}

.a7-painel-mobile {
  background-color: $white;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.superior {
  z-index: 1;
  position: sticky;
  background-color: $grey-light;
}

.navigation {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-weight: $weight;
  border-bottom: 1px solid $grey-lighter;
  background-color: $white;
  &:first-child{
    background-color: $grey-darker;
    color: white;
    padding: 4px 0px;
  }
  .item {
    width: 100%;
    height: 20px;
    margin: 0px;
    align-self: flex-start;
  }
  .pai-container {
    display: flex;
    align-items: center;
    padding-left: 5px;
    .pai{
      text-decoration: underline;
      align-items: center;
      font-size: $tamanhoFonteMedia;
      margin-left: 5px;
    }
  }
  .title {
    white-space: nowrap;
    font-size: $tamanhoFonteGrande;
    margin: 0px 10px;
  }
}

.lista {
  padding-top: 0px;
  overflow: auto;
  flex-grow: 1;
}
</style>
